export default function DashboardIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 5H11V18H13V5ZM6 9H8V18H6V9ZM16 12H18V18H16V12Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
